import { getBackendEnv } from "./consts";

const latestVersionLink = {
  dev: "https://assets.blings.io/scripts/msdkDev4.js",
  master: "https://assets.blings.io/scripts/msdk4.js",
};

export async function getLatestPlayerVersion() {
  const env = getBackendEnv() === "master" ? "master" : "dev";
  const sdkScript = await fetch(latestVersionLink[env], {
    headers: {
      accept: "application/javascript",
    },
  });
  const sdkScriptText = await sdkScript.text();
  const versionRegex = /\|\|\\?"\s*(\d+-\d+-\d+)/;
  const version = versionRegex.exec(sdkScriptText)?.[1];
  return version;
}
